import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";

export interface TableResultProps {
  results?: {
    u2relFa: string | number | null;
    polinomioAjuste: string | null;
    coefficients: {
      grade2: string | number | null;
      grade1: string | number | null;
      independent: string | number | null;
      r2: string | number | null;
    };
  } | null;
}

const TableResult = ({ results }: TableResultProps) => {
  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6">Resultados</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>
                Cálculo de la incertidumbre relativa del factor de auto
                absorción al cuadrado (u2relFa)
              </TableCell>
              <TableCell>
                {!Number.isNaN(results?.u2relFa) ? results?.u2relFa : ""}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Coeficientes polinomio de ajuste (Grado 2º)</TableCell>
              <TableCell>{results?.coefficients?.grade2}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Coeficientes polinomio de ajuste (Grado 1º)</TableCell>
              <TableCell>{results?.coefficients?.grade1}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                Coeficientes polinomio de ajuste (Independiente)
              </TableCell>
              <TableCell>{results?.coefficients?.independent}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>R2</TableCell>
              <TableCell>
                {isNaN(Number(results?.coefficients?.r2))
                  ? ""
                  : results?.coefficients?.r2}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Ecuación polinómica de ajuste:</TableCell>
              <TableCell>{results?.polinomioAjuste}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TableResult;
